<template>
    <v-modal title="Override Settings" @close="$emit('close')">
        <div slot="content">
            <p class="stack-m">Would you like to override settings for tab <r-badge>{{label}}</r-badge></p>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="override">Override</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';

    export default {
        name: 'merge-settings-modal',
        components: {
            vModal,
        },
        props: {
            settings: {
                type: Object,
                default: null,
            },
        },
        computed: {
            label() {
                return this.settings && this.settings.tab && this.settings.tab.label;
            },
        },
        methods: {
            override() {
                this.$emit('override');
            },
        },
    };
</script>
